import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from '@mui/material';
import InterveneSearchField from './InterveneSearchField';
import useDialerCall from '../hooks/useDialerCall';
import useInterveneSx from '../hooks/useInterveneSx';
import { spacing } from '../../../theme/tokens';
import { DIALER_CALL_COPY } from '../constants/dialerCallCopy';

export default function DialerCallDialog({ open, onClose, userDetails }) {
  const styles = useInterveneSx().dialog;
  const copy = DIALER_CALL_COPY;
  const {
    formData,
    errors,
    agents,
    callerIds,
    isSubmitting,
    selectAgent,
    selectCallerId,
    submit,
  } = useDialerCall({
    open,
    phoneNumber: userDetails?.phone_number,
    onClose,
  });

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: styles.paper }}>
      <DialogTitle sx={styles.title}>{copy.title}</DialogTitle>
      <DialogContent sx={styles.content}>
        <DialogContentText sx={{ mb: spacing.size1, color: 'text.secondary' }}>
          {copy.description}
        </DialogContentText>

        <TextField
          fullWidth
          label={copy.fields.customerNumber.label}
          size="small"
          value={formData.destination_number}
          disabled
          helperText={copy.fields.customerNumber.helper}
          sx={{ ...styles.field, mb: spacing.size1 }}
        />

        <InterveneSearchField
          spaced
          required
          value={formData.agent}
          onChange={selectAgent}
          label={copy.fields.agent.label}
          placeholder={copy.fields.agent.placeholder}
          labelKey="name"
          valueKey="follow_me_number"
          options={agents}
          error={!!errors.agent_number}
          helperText={errors.agent_number || copy.fields.agent.helper}
          sx={{ mb: spacing.size1 }}
        />

        <InterveneSearchField
          spaced
          required
          value={formData.tollFree}
          onChange={selectCallerId}
          label={copy.fields.callFrom.label}
          placeholder={copy.fields.callFrom.placeholder}
          labelKey="tollfree_number"
          valueKey="id"
          options={callerIds}
          error={!!errors.caller_id}
          helperText={errors.caller_id || copy.fields.callFrom.helper}
          sx={{ mb: 0 }}
        />
      </DialogContent>
      <DialogActions sx={styles.actions}>
        <Button onClick={onClose} disabled={isSubmitting} sx={styles.cancelButton}>
          {copy.actions.cancel}
        </Button>
        <Button variant="contained" onClick={submit} disabled={isSubmitting} sx={styles.submitButton}>
          {isSubmitting ? copy.actions.submitting : copy.actions.submit}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
